module.exports = __webpack_public_path__ + "static/media/18_A.95d57f69.png";